import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { DocIcon } from "@/components/canvas/LosBits";
import { docTitle } from "@/components/canvas/DocViewer";

const RANK = { xlsx: 0, docx: 1, msg: 2, text: 3, pdf: 4, zip: 5, dwg: 6, other: 7, image: 8 };
const KIND = { pdf: ["PDF", "PDF"], image: ["bilde", "bilder"], xlsx: ["regneark", "regneark"], docx: ["Word", "Word"], msg: ["e-post", "e-poster"] };
const FOLD = 8;
const SHOWN = 6;

const kindSummary = (docs) => {
  const n = {};
  docs.forEach((d) => { const k = KIND[d.kind] ? d.kind : "other"; n[k] = (n[k] || 0) + 1; });
  return Object.entries(n).sort((a, b) => b[1] - a[1]).map(([k, c]) => `${c} ${k === "other" ? (c === 1 ? "annen" : "andre") : KIND[k][c === 1 ? 0 : 1]}`).join(" · ");
};

/** The documents as chips you can open – a large folder shows the request's own files first and folds the rest behind one line. */
export function DocChips({ docs, onOpen }) {
  const [all, setAll] = useState(false);
  const sorted = [...docs].sort((a, b) => (RANK[a.kind] ?? 7) - (RANK[b.kind] ?? 7));
  const fold = sorted.length > FOLD;
  const shown = fold && !all ? sorted.slice(0, SHOWN) : sorted;
  return (
    <div className="mt-4 px-6" data-testid="intake-f-docs" data-folded={fold && !all ? "1" : "0"}>
      {fold ? <div className="mb-2 text-[12px] text-muted-foreground" data-testid="intake-f-docs-summary">{sorted.length} dokumenter · {kindSummary(sorted)}</div> : null}
      <div className="flex flex-wrap gap-1.5">
        {shown.map((d) => (
          <button key={d.id} type="button" onClick={() => onOpen(d.id)} className="inline-flex h-8 max-w-[260px] items-center gap-1.5 rounded-full border border-black/[0.08] bg-white px-2.5 text-[12.5px] text-foreground/80 transition-colors hover:border-black/[0.2] hover:text-foreground" title={d.name} data-testid={`intake-f-doc-${d.id}`}>
            <DocIcon kind={d.kind} className="h-3.5 w-3.5 shrink-0 text-muted-foreground" /><span className="truncate">{docTitle(d)}</span>{d.pages ? <span className="shrink-0 text-muted-foreground/70">{d.pages} s.</span> : null}
          </button>
        ))}
        {fold ? (
          <button type="button" onClick={() => setAll((v) => !v)} className="inline-flex h-8 items-center gap-1 rounded-full px-2.5 text-[12.5px] font-medium text-[hsl(var(--navy))] transition-colors hover:bg-black/[0.04]" data-testid="intake-f-docs-more">
            {all ? "Vis færre" : `${sorted.length - SHOWN} til`} <ChevronDown className={cn("h-3.5 w-3.5 transition-transform", all && "rotate-180")} />
          </button>
        ) : null}
      </div>
    </div>
  );
}
